import type { AreaCatalog } from '../area';
import type { itemActions as en } from '../en/itemActions';

export const itemActions = {
  'itemActions.cascade.justThis': 'Nur diese',
  'itemActions.cascade.alsoFinishes': 'Stellt auch fertig: {titles}',
  'itemActions.cascade.closeAll': {
    one: 'Alle {count} fertigstellen',
    other: 'Alle {count} fertigstellen',
  },
  'itemActions.cancel': 'Abbrechen',
  'itemActions.review.notePlaceholder': 'Optionaler Kommentar…',
  'itemActions.review.noteLabel': 'Kommentar zur Bewertung',
  'itemActions.review.followUpPlaceholder':
    'Folgeaufgabe (technische Schulden, Nacharbeit, später darauf zurückkommen…)',
  'itemActions.review.followUpTitle': 'Titel der Folgeaufgabe {n}',
  'itemActions.review.followUpDuePlaceholder': 'Fällig (2026-09-30, 2026-W40)',
  'itemActions.review.followUpDue': 'Fälligkeit der Folgeaufgabe {n}',
  'itemActions.review.removeFollowUp': 'Folgeaufgabe {n} entfernen',
  'itemActions.review.addFollowUp': '+ Folgeaufgabe',
  'itemActions.review.accept': 'Annehmen',
  'itemActions.review.deny': 'Ablehnen',
  'itemActions.review.outOfRole': 'nicht zuständig',
  'itemActions.review.flagCritical':
    'Nicht zuständig (in eigener Sache): wird als kritisch protokolliert.',
  'itemActions.review.flagWarning': 'Nicht zuständig: wird als Warnung protokolliert.',
  'itemActions.stage.menu': 'In Phase verschieben',
  'itemActions.stage.trigger': 'Phase: {word}. „{title}“ in eine andere Phase verschieben',
  'itemActions.stage.applies': 'setzt {means}',
  'itemActions.stage.loading': 'Wird geladen…',
  'itemActions.stage.loadFailed':
    'Die Phasen konnten nicht geladen werden. Schließ das Menü und versuch es noch einmal.',
  'itemActions.stateChip.active': 'Aktiv',
  'itemActions.stateChip.idle': 'Ruhend',
  'itemActions.stateChip.review': 'Review',
  'itemActions.stateChip.done': 'Fertig',
  'itemActions.stateChip.cancelled': 'Abgebrochen',
} as const satisfies AreaCatalog<typeof en>;
